import moment from "moment";
import {
  ETHIZO_PRACTICE_ID,
  SOUTHSIDE_MEDICAL_CENTER_ID,
} from "../../constants/practiceIds";

const AUTO_SCHEDULE_PRACTICE_IDS = [
  ETHIZO_PRACTICE_ID,
  SOUTHSIDE_MEDICAL_CENTER_ID,
];

export const isAutoSchedulePractice = (practiceId) =>
  AUTO_SCHEDULE_PRACTICE_IDS.some(
    (id) => id?.toString() === practiceId?.toString()
  );

export const getAppointmentSubmitStatus = (practiceId) =>
  isAutoSchedulePractice(practiceId) ? "scheduled" : "pending";

export const formatAppointmentTimeRange = (appointmentData) => {
  if (!appointmentData?.apt_start_time) return "";

  return (
    moment(appointmentData.apt_start_time, "HH:mm:ss").format("hh:mm A") +
    " - " +
    moment(appointmentData.apt_end_time, "HH:mm:ss").format("hh:mm A") +
    " (" +
    appointmentData.duration +
    " mins)"
  );
};

export const getAppointmentSuccessMessage = (practiceId, appointmentData) => {
  const timeRange = formatAppointmentTimeRange(appointmentData);
  const timeText = timeRange ? ` ${timeRange}` : "";

  if (isAutoSchedulePractice(practiceId)) {
    return `Thank you for submitting your appointment request${timeText}. Your appointment has been scheduled.`;
  }

  return `Thank you for submitting your appointment request${timeText}. Your appointment is pending for approval. It is not confirmed until a staff member reaches out to you.`;
};
